import { clearHelperState } from '@/actions/helperAction';
import {
  clearCommentReplyData,
  clearRoomData,
  clearRoomError,
  clearRoomQuery,
  commentDiscussionData,
  deleteRoomDiscussion,
  getDiscussionsByPage,
  initialRoomDisscussionCommentQuery,
  initialRoomDisscussionCommentReplyQuery,
  reportDiscussion,
  setRoomEditData,
  setRoomQueryData,
} from '@/actions/room';
import { NewLinkPreview } from '@/components/common/LinkPreview';
import AvatarComponent from '@/components/common/avatar';
import ReadMore, { newlineText } from '@/components/common/read-more';
import CustomModal from '@/components/landing/doubt/common/custom-action';
import { FlagOutlined } from '@ant-design/icons';
import {
  Button,
  Dropdown,
  Empty,
  Form,
  Image,
  Modal,
  Radio,
  Skeleton,
  notification,
} from 'antd';
import moment from 'moment';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import CommentSection from './Components/Comments';
import EmojisCountModal from './Components/EmojisCountModal';
import LikeAndCommentSection from './Components/LikeAndCommentSection';
import { PostMenu } from './Components/Menu';
import DiscussionModal from './Components/discussion-modal';
import Poll from './Components/poll';
import useWidth from '@/helpers/widthUtil';

const Discussion = ({ roomId, roomSlug, roomData }) => {
  const router = useRouter();
  const { isMobile, isTablet } = useWidth();
  const dispatch = useDispatch();
  const discussionObserver: any = useRef();
  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();

  // Local States
  const arr = [1, 2, 3];
  const [state, setState] = useState({
    open: {},
  });
  const [reactionPostId, setReactionPostId] = useState('');
  const [reactionCommentId, setReactionCommentId] = useState('');
  const [reactionReplyId, setReactionReplyId] = useState('');
  const [reactionPostData, setReactionPostData] = useState([]);
  const [reactionCommentData, setReactionCommentData] = useState([]);
  const [reactionRepliesData, setReactionRepliesData] = useState([]);
  const [postCreator, setPostCreator] = useState(null);
  const [discussionId, setDiscussionId] = useState(null);
  const [commentDiscussionId, setCommentDiscussionId] = useState(null);
  const [commentEditId, setCommentEditId] = useState(false);
  const [replyEditId, setReplyEditId] = useState(false);
  const [reportVisible, setReportVisible] = useState(false);
  const [radioValue, setradioValue] = useState(null);
  const [hasMoreDiscussion, setHasMoreDiscussion] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const [postFile, setPostFile] = useState(null);
  const [addModal, setaddModal] = useState(false);
  const [isDiscussionReaction, setIsDiscussionReaction] = useState(false);
  const [isCommentReaction, setIsCommentReaction] = useState(false);
  const [isReplyReaction, setIsReplyReaction] = useState(false);
  const [emojiCountModal, setEmojiCountModal] = useState(false);
  const [isPostImage, setIsPostImage] = useState(false);
  const [createPostPoll, setCreatePostPoll] = useState(false);
  const [createPoll, setCreatePoll] = useState(false);
  const [pollItems, setPollItems] = useState(['', '', '']);
  const [editData, setEditData] = useState({});

  // Discussion Datas
  const roomDiscussions = useSelector((state: any) => state.roomReducer.discussions);
  const roomDiscussionComments = useSelector(
    (state: any) => state.roomReducer.discussionComments
  );
  const isRoomMember = useSelector(
    (state: any) => state?.roomReducer?.roomDetail?.data?.is_member
  );
  const query = useSelector((state: any) => state.roomReducer.query);
  const user = useSelector((state: any) => state.auth?.creds?.user_data);
  const roomError = useSelector((state: any) => state.roomReducer?.error);
  const { discussions: discussionError } = roomError;
  const { discussions: discussionQuery } = query;

  const {
    data: commentData,
    meta: {},
    comments,
    replies,
  } = roomDiscussionComments;

  const {
    data,
    getRoomDiscussionStatus,
    meta: discussionMeta,
    getMoreDiscussionStatus,
    addRoomDiscussionStatus,
    editRoomDiscussionStatus,
    deleteRoomDiscussionStatus,
    reportDiscussionStatus,
  } = roomDiscussions;

  useEffect(() => {
    dispatch(clearRoomQuery());
    dispatch(clearRoomData());
    dispatch(clearRoomError());
    dispatch(
      setRoomEditData({
        name: 'discussions',
        key: 'reportDiscussionStatus',
        value: '',
      })
    );
    dispatch(clearHelperState());
    return () => {
      setHasMoreDiscussion(false);
      setDiscussionId(null);
      setCommentDiscussionId(null);
      setReactionPostId(null);
    };
  }, []);

  useEffect(() => {
    setHasMoreDiscussion(
      discussionMeta?.last_pages === discussionQuery?.page
        ? false
        : // Make sure if user deleted the post and redux is not updated page and don't show anything when displays error
        Object.keys(discussionError)?.length !== 0 &&
          discussionError?.discussions?.message === null
        ? false
        : true
    );
  }, [discussionMeta, discussionError]);

  useEffect(() => {
    if (comments[discussionId]?.getRoomDiscussionComments === 'success') {
      dispatch(
        initialRoomDisscussionCommentQuery({
          payload: {
            discussionId,
            room: roomSlug,
          },
        })
      );
    }
  }, [comments[discussionId]?.getRoomDiscussionComments]);

  useEffect(() => {
    if (
      replies[commentDiscussionId]?.getRoomDiscussionCommentReplies === 'success'
    ) {
      dispatch(
        initialRoomDisscussionCommentReplyQuery({
          payload: {
            commentDiscussionId,
            room: roomSlug,
          },
        })
      );
    }
  }, [replies[commentDiscussionId]?.getRoomDiscussionCommentReplies]);

  useEffect(() => {
    if (
      roomDiscussionComments.discussionId &&
      comments[roomDiscussionComments.discussionId]
        .editRoomDiscussionCommentStatus === 'success'
    ) {
      setCommentEditId(null);
      dispatch(commentDiscussionData());
    }
  }, [
    roomDiscussionComments.discussionId &&
      comments[roomDiscussionComments.discussionId].editRoomDiscussionCommentStatus,
  ]);

  useEffect(() => {
    if (
      roomDiscussionComments.commentId &&
      replies[roomDiscussionComments.commentId].editRoomDiscussionCommentReplies ===
        'success'
    ) {
      setReplyEditId(null);
      dispatch(clearCommentReplyData());
    }
  }, [
    roomDiscussionComments.commentId &&
      replies[roomDiscussionComments.commentId].editRoomDiscussionCommentReplies,
  ]);

  useEffect(() => {
    if (reportDiscussionStatus === 'success') {
      setReportVisible(false);
      setradioValue('');
      notification.success({
        message: 'Your Report has been successfully submitted.',
      });
    }
  }, [reportDiscussionStatus]);

  useEffect(() => {
    if (deleteRoomDiscussionStatus === 'success') {
      setdeleteModal(false);
    }
  }, [deleteRoomDiscussionStatus]);

  useEffect(() => {
    if (editRoomDiscussionStatus === 'success') {
      seteditModal(false);
      editForm.resetFields();
      setPostFile(null);
    }
  }, [editRoomDiscussionStatus]);

  useEffect(() => {
    if (addRoomDiscussionStatus === 'success') {
      setaddModal(false);
      addForm.resetFields();
      setPostFile(null);
      setPollItems([]);
      dispatch(clearHelperState());
    }
  }, [addRoomDiscussionStatus]);

  // Fetch data when user reaches bottom of the post
  const lastDiscussionElementRef = useCallback(
    (node) => {
      if (
        getRoomDiscussionStatus === 'request' ||
        getMoreDiscussionStatus === 'request'
      )
        return;
      if (discussionObserver.current) discussionObserver.current.disconnect();
      discussionObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreDiscussion) {
          dispatch(
            setRoomQueryData({
              name: 'discussions',
              value: {
                ...discussionQuery,
                room: roomSlug,
                page: discussionMeta.current_page + 1,
              },
            })
          );
          dispatch(
            getDiscussionsByPage({
              data: {
                ...discussionQuery,
                room: roomSlug,
                page: discussionMeta.current_page + 1,
              },
            })
          );
        }
      });
      if (node) discussionObserver.current.observe(node);
    },
    [
      getMoreDiscussionStatus === 'request',
      getRoomDiscussionStatus === 'request',
      hasMoreDiscussion,
    ]
  );

  // Edit Discussion Click
  const handleEditClick = (editValue) => {
    setEditData(editValue);
    // setIsPoll(editValue?.is_poll);
    setCreatePoll(false);
    editForm.setFieldsValue({
      text: editValue?.text,
      image: editValue?.image,
    });
    seteditModal(true);
    setDiscussionId(editValue.id);
  };

  const radioChange = (e) => {
    setradioValue(e.target.value);
  };

  // Report Discussion
  const reportFeed = () => {
    const data = {
      doubt: discussionId,
      report_type: radioValue,
    };
    dispatch(reportDiscussion({ data }));
  };

  // Delete discussion
  const deleteDiscussionPost = (e, discussionId) => {
    dispatch(deleteRoomDiscussion({ discussionId }));
  };

  return (
    <>
      {/* Add Modal */}
      <DiscussionModal
        roomId={roomId}
        discussionId={discussionId}
        postFile={postFile}
        setPostFile={setPostFile}
        form={addForm}
        visible={addModal}
        title="Create Post"
        onCancel={() => {
          setaddModal(false);
        }}
        loading={addRoomDiscussionStatus === 'request'}
        editData={''}
        formType="add"
        setPollItems={setPollItems}
        pollItems={pollItems}
        createPoll={createPoll}
        setCreatePoll={setCreatePoll}
        roomTitle={roomData?.title}
        createPostPoll={createPostPoll}
        setCreatePostPoll={setCreatePostPoll}
        isPostImage={isPostImage}
        setIsPostImage={setIsPostImage}
      />
      {/* Edit Modal */}
      {editModal && (
        <DiscussionModal
          roomId={roomId}
          discussionId={discussionId}
          postFile={postFile}
          setPostFile={setPostFile}
          form={editForm}
          visible={editModal}
          title="Edit Post"
          onCancel={() => seteditModal(false)}
          loading={editRoomDiscussionStatus === 'request'}
          editData={editData}
          formType="edit"
          setPollItems={setPollItems}
          pollItems={pollItems}
          createPoll={createPoll}
          setCreatePoll={setCreatePoll}
          roomTitle={roomData?.title}
          createPostPoll={createPostPoll}
          setCreatePostPoll={setCreatePostPoll}
          isPostImage={isPostImage}
          setIsPostImage={setIsPostImage}
        />
      )}
      {/* Delete Modal */}
      <CustomModal
        key={2}
        title="Delete this Discussion Post?"
        visible={deleteModal}
        closeModal={() => setdeleteModal(false)}
        buttonName="Delete"
        action={(e) => deleteDiscussionPost(e, discussionId)}
        content={
          <p className="text-dark">
            Are you sure want to edit? This Process cannot be undone?
          </p>
        }
        loading={deleteRoomDiscussionStatus === 'request'}
      />
      <Modal
        visible={reportVisible}
        onCancel={() => setReportVisible(false)}
        footer={false}
        maskClosable={false}
        className="feed-report-modal rounded"
        title={
          <div className="d-flex">
            <FlagOutlined rev="" style={{ fontSize: '26px' }} />{' '}
            <h3 className="mt-1">Report</h3>
          </div>
        }
      >
        <div className="p-1">
          <div className="d-flex flex-column">
            <Radio.Group onChange={radioChange} value={radioValue}>
              <div className="col p-2 bg-muted">
                <Radio value={'spam'}>
                  <span>Spam</span>
                </Radio>
              </div>
              <div className="col p-2 mb-2">
                <Radio value={'inappropriate'}>
                  <span>InAppropirate Content</span>
                </Radio>
              </div>
              <div className="col  p-2 mb-2">
                <Radio value={'outoftopic'}>
                  <span>Out of Topic</span>
                </Radio>
              </div>
            </Radio.Group>
          </div>
        </div>
        <Button
          loading={reportDiscussionStatus === 'request'}
          onClick={reportFeed}
          className="btn-secondary border-danger ml-auto"
        >
          Send
        </Button>
      </Modal>{' '}
      {emojiCountModal && (
        <EmojisCountModal
          visible={emojiCountModal}
          onCancel={() => {
            setIsDiscussionReaction(false);
            setIsCommentReaction(false);
            setIsReplyReaction(false);
            setEmojiCountModal(false);
          }}
          emojiData={
            (isDiscussionReaction && reactionPostData) ||
            (isCommentReaction && reactionCommentData) ||
            (isReplyReaction && reactionRepliesData)
          }
          postId={reactionPostId}
          commentId={reactionCommentId}
          replyId={reactionReplyId}
          isDiscussion={isDiscussionReaction}
          isComment={isCommentReaction}
          isReplies={isReplyReaction}
        />
      )}
      <div className={`container mb-5 ${isTablet && 'px-0'}`}>
        <div className="row">
          <div className={` ${isMobile && 'px-0'} col-lg-12 discussion-feeds`}>
            {roomData?.roommember?.member_status == 1 ||
            roomData?.member_status === '1' ? (
              <>
                <div
                  className=" bg-white px-3 pt-3 pb-2 mb-3"
                  style={{
                    borderRadius: '8px',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <div className="d-flex align-items-center border-bottom pb-3 gap-2">
                    <div>
                      <AvatarComponent
                        avatar={user?.avatar}
                        size={40}
                        firstName={user?.first_name}
                        lastName={user?.last_name}
                      />
                    </div>
                    <input
                      readOnly={true}
                      className="input-hover-border cursor-pointer border-0 font-placeholder w-100 pl-3"
                      style={{
                        borderRadius: '20px',
                        backgroundColor: '#F0F2F5',
                        height: '40px',
                      }}
                      placeholder="Write something. . ."
                      onClick={() => setaddModal(true)}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-around mt-2">
                    <div
                      className="d-flex align-items-center hover-bg justify-content-center  cursor-pointer py-2 px-4 w-100"
                      onClick={() => {
                        setaddModal(true);
                        setIsPostImage(true);
                      }}
                    >
                      <img
                        src={'/images/photo-discussion.webp'}
                        alt="photo-discussion"
                        height={'24'}
                        width={'24'}
                      />
                      <span
                        className="font-weight-bold ml-2"
                        style={{ fontSize: '14px' }}
                      >
                        Photo
                      </span>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-center  hover-bg cursor-pointer py-2 px-4 w-100"
                      onClick={() => {
                        setaddModal(true);
                        setCreatePostPoll(true);
                      }}
                    >
                      <img
                        src={'/images/poll-discussion.webp'}
                        alt="poll-discussion"
                        height={'24'}
                        width={'24'}
                      />
                      <span
                        className="font-weight-bold ml-2"
                        style={{ fontSize: '14px' }}
                      >
                        Poll
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
            {getRoomDiscussionStatus === 'request' ? (
              arr.map((each, idx) => (
                <div
                  className="discussion-feed p-2 mb-3"
                  key={idx}
                  style={{ borderRadius: '10px' }}
                >
                  <div className="d-flex justify-content-start align-items-center p-3">
                    <Skeleton.Avatar />
                    <Skeleton.Button size={'small'} className="ml-2" />
                    <Skeleton.Input />
                  </div>
                  <div className="discussion-content p-3">
                    <Skeleton active>
                      {
                        <div className="tags p-1 d-flex flex-wrap justify-content-start">
                          {arr.map((topic) => (
                            <span className="tag shadow-sm ml-2" key={topic}></span>
                          ))}
                        </div>
                      }
                    </Skeleton>
                    <Skeleton.Image
                      className="d-flex justify-content-center"
                      style={{ width: '692px' }}
                    />
                  </div>
                </div>
              ))
            ) : data?.length !== 0 ? (
              data?.map((each, index) => (
                <div
                  ref={data?.length === index + 1 ? lastDiscussionElementRef : null}
                  key={each.id}
                  className="mb-3"
                >
                  <div
                    className={`${
                      parseInt(router?.query?.discussion as string) === each?.id &&
                      'animation-card'
                    } discussion-feed`}
                    style={{
                      borderRadius: '8px',
                      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                      borderBottomLeftRadius: `${state.open[each?.id] ? '' : '8px'}`,
                      borderBottomRightRadius: `${
                        state.open[each?.id] ? '' : '8px'
                      }`,
                    }}
                  >
                    <div className="d-flex gap-2 justify-content-start align-items-center post-headers px-3 pt-3">
                      <AvatarComponent
                        size={36}
                        firstName={each.created_by.first_name}
                        lastName={each.created_by.last_name}
                        avatar={each.created_by.avatar}
                      />
                      <div>
                        <span className="user-name">
                          {each.created_by.first_name} {each.created_by.last_name}
                        </span>
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted d-time d-block">
                            {moment(each.created_at).fromNow()}
                          </span>
                          <i className="fas fa-users"></i>
                        </div>
                      </div>
                      <Dropdown
                        overlay={
                          <PostMenu
                            editValue={each}
                            user={user}
                            postCreator={postCreator}
                            handleEditClick={handleEditClick}
                            setdeleteModal={setdeleteModal}
                            setReportVisible={setReportVisible}
                          />
                        }
                        placement="bottomLeft"
                        className="dropdown-ml ml-auto"
                        trigger={['click']}
                        overlayStyle={{ minWidth: '160px' }}
                      >
                        <div
                          className="edit-post-button"
                          onClick={() => {
                            each?.image && setIsPostImage(true);
                            setPostCreator(each.created_by.id);
                            setDiscussionId(each.id);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="12" r="1"></circle>
                            <circle cx="12" cy="5" r="1"></circle>
                            <circle cx="12" cy="19" r="1"></circle>
                          </svg>
                        </div>
                      </Dropdown>
                    </div>
                    <div
                      className={`discussion-content mt-2 ${
                        !isRoomMember && 'pb-3'
                      }`}
                    >
                      <ReadMore
                        style={{
                          // marginBottom: '-25px',
                          marginTop: '5px',
                          // whiteSpace: 'pre-line font',
                          fontSize: '14px',
                        }}
                        className="text-justify px-3"
                        text={newlineText(each.text)}
                      />

                      {each?.topic?.length !== 0 && (
                        <div className="tags p-1 d-flex flex-wrap justify-content-start px-3">
                          {each?.topic?.map((topic) => (
                            <span className="tag shadow-sm" key={topic.id}>
                              {topic.topic}
                            </span>
                          ))}
                        </div>
                      )}
                      {each?.image ? (
                        <div className="discussion-image text-center mt-1">
                          <picture>
                            <source type="image/svg+xml" />
                            <Image
                              className="img-responsive d-block"
                              src={each?.image}
                            />
                          </picture>
                        </div>
                      ) : (
                        each?.website_info && (
                          <div className="mb-2 px-3">
                            <NewLinkPreview website_info={each?.website_info} />
                          </div>
                        )
                      )}

                      {each?.is_poll && <Poll each={each} />}

                      {isRoomMember && (
                        <LikeAndCommentSection
                          setDiscussionId={setDiscussionId}
                          roomSlug={roomSlug}
                          setState={setState}
                          each={each}
                          state={state}
                          setIsDiscussionReaction={setIsDiscussionReaction}
                          setReactionPostData={setReactionPostData}
                          setReactionPostId={setReactionPostId}
                          setEmojiCountModal={setEmojiCountModal}
                        />
                      )}
                    </div>
                  </div>
                  {isRoomMember && (
                    <CommentSection
                      roomId={roomId}
                      discussionId={discussionId}
                      state={state}
                      each={each}
                      setState={setState}
                      setCommentEditId={setCommentEditId}
                      commentEditId={commentEditId}
                      setIsCommentReaction={setIsCommentReaction}
                      setReactionCommentData={setReactionCommentData}
                      setReactionCommentId={setReactionCommentId}
                      setEmojiCountModal={setEmojiCountModal}
                      setCommentDiscussionId={setCommentDiscussionId}
                      setReplyEditId={setReplyEditId}
                      replyEditId={replyEditId}
                      user={user}
                      setIsReplyReaction={setIsReplyReaction}
                      setReactionRepliesData={setReactionRepliesData}
                      setReactionReplyId={setReactionReplyId}
                      roomSlug={roomSlug}
                    />
                  )}
                </div>
              ))
            ) : (
              <div className="mt-3">
                <Empty description="No Discussion yet in this room." />
              </div>
            )}
            {getMoreDiscussionStatus === 'request' && (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner animation="border" className="mt-3" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Discussion;
